module.exports = __webpack_public_path__ + "img/content_title_sp.c598b25c.svg";